const measurement = (label, fullform, unit, yAxis, display = false) => ({
  label,
  unit,
  display,
  fullform,
  yAxis,
  loading: false
});

export const isEcofrostV4 = (details = {}, topic = '') => {
  if (details.isV4Device === true) {
    return true;
  }

  return (
    details.MCU_RM1_TEMP !== undefined ||
    details.MCU_HRM !== undefined ||
    details.MCU_SWV !== undefined
  );
};

const v4Measurements = () => [
  // measurement('Topic', 'Topic', '', 'Decimal'),
  // measurement('TBN', 'Topic Base Name', '', 'Decimal'),

  // measurement('RMU_TSP', 'Telecom Service Provider', '', 'Decimal'),
  // measurement('RMU_APN', 'Access Point Name', '', 'Decimal'),
  // measurement('RMU_SNG', 'Signal Strength', 'dBm', 'Signal Strength'),
  // measurement('RMU_LOG_INT', 'Datalog Interval', 'sec', 'Time'),
  // measurement('RMU_LATT', 'Latitude', '', 'Decimal'),
  // measurement('RMU_LONG', 'Longitude', '', 'Decimal'),
  // measurement('RMU_ICCID', 'SIM ICCID', '', 'Decimal'),
  // measurement('RMU_ROOM1_RD_CRP', 'Room 1 Read Crop', '', 'Decimal'),
  // measurement('RMU_ROOM1_AD_CRP', 'Room 1 Add Crop', '', 'Decimal'),
  // measurement('RMU_ROOM1_RM_CRP', 'Room 1 Remove Crop', '', 'Decimal'),
  // measurement('RMU_ROOM2_RD_CRP', 'Room 2 Read Crop', '', 'Decimal'),
  // measurement('RMU_ROOM2_AD_CRP', 'Room 2 Add Crop', '', 'Decimal'),
  // measurement('RMU_ROOM2_RM_CRP', 'Room 2 Remove Crop', '', 'Decimal'),
  // measurement('RMU_SWV', 'Quectel Application Software Version', '', 'Decimal'),
  // measurement('RMU_BSV', 'Quectel Base Software Version', '', 'Decimal'),
  // measurement('RMU_SYS_NUM', 'System Number', '', 'Decimal'),
  // // measurement('RMU_CUS_PH_NO', 'Customer Phone Number', '', 'Decimal'),
  // measurement('RMU_SYS_UPTIME', 'RMU System Uptime', 'sec', 'Time'),
  // measurement('RMU_RESET', 'RMU Reset', '', 'Fault/Status'),
  // measurement('RMU_FILE_SIZE', 'Current File Size', '', 'Decimal'),
  // measurement('RMU_Resv_1', 'RMU Reserved 1', '', 'Decimal'),
  // measurement('RMU_Resv_2', 'RMU Reserved 2', '', 'Decimal'),
  // measurement('RMU_Resv_3', 'RMU Reserved 3', '', 'Decimal'),
  // measurement('RMU_Resv_4', 'RMU Reserved 4', '', 'Decimal'),
  // measurement('RMU_Resv_5', 'RMU Reserved 5', '', 'Decimal'),
  // measurement('MCU_SWV', 'MCU Software Version', '', 'Decimal'),
  // measurement('MCU_HRM', 'HMI Rolling Message', '', 'Decimal'),
  // measurement('MCU_UPTIME', 'MCU System Uptime', 'sec', 'Time'),
  measurement('MCU_PWR_IP', 'Power Input', '', 'Decimal'),
  measurement('MCU_PSM', 'Power Source Mode', '', 'Fault/Status'),
  // measurement('MCU_PRECOOL_M', 'Precooling Mode', '', 'Fault/Status'),
  // measurement('MCU_TANK_SELECT', 'Tank Select', '', 'Decimal'),
  measurement('MCU_R_PH_V', 'R Phase Voltage', 'V', 'Voltage'),
  measurement('MCU_Y_PH_V', 'Y Phase Voltage', 'V', 'Voltage'),
  measurement('MCU_B_PH_V', 'B Phase Voltage', 'V', 'Voltage'),
  measurement('MCU_PV_I_A', 'Solar Input Current', 'A', 'Current'),
  // measurement('MCU_ADC_CAL', 'ADC Calibration', '', 'Decimal'),
  measurement('MCU_PV_ENERGY', 'Solar Energy consumed', 'kWh', 'Energy'),
  measurement('MCU_GRID_ENERGY', 'Grid Energy consumed', 'kWh', 'Energy'),
  // measurement('MCU_BUCK_DELTA', 'Buck Delta', '', 'Decimal'),
  // measurement('MCU_PV_V_THR', 'Solar Voltage Threshold', 'V', 'Voltage'),
  // measurement('MCU_PV_SWITCH_THR', 'Solar Switch Threshold', 'V', 'Voltage'),
  // measurement(
  //   'MCU_LOW_BAT_BUCK_ON_THR',
  //   'Low Battery Buck On Threshold',
  //   'V',
  //   'Voltage'
  // ),
  // measurement('MCU_IDU_PWM_D', 'IDU PWM Duty', '%', 'Percentage'),
  // measurement('MCU_CDU_PWM_D', 'CDU PWM Duty', '%', 'Percentage'),
  // measurement('MCU_RLT', 'RTC Local Time', 'sec', 'Time'),
  // measurement('MCU_AC_DC_SPD_ST', 'AC/DC SPD Status', '', 'Fault/Status'),
  // measurement('MCU_BOOT', 'Boot Status', '', 'Fault/Status'),
  // measurement(
  //   'MCU_MIN_AMB_TEMP',
  //   'Minimum Ambient Temperature',
  //   '°C',
  //   'Temperature'
  // ),
  // measurement(
  //   'MCU_MIN_AMB_TEMP_THR',
  //   'Minimum Ambient Temperature Threshold',
  //   '°C',
  //   'Temperature'
  // ),
  measurement('MCU_PNL_BOX_TEMP', 'Panel Box Temperature', '°C', 'Temperature'),
  measurement('MCU_AMB_TEMP', 'Ambient Temperature', '°C', 'Temperature'),
  measurement('MCU_AMB_HUM', 'Ambient Humidity', '%', 'Humidity'),
  // measurement('MCU_SET_PARAM', 'Set Parameter', '', 'Decimal'),
  // measurement('MCU_VLV_ON_DLY', 'Valve On Delay', 'sec', 'Time'),
  measurement(
    'MCU_RM1_SET_TEMP',
    'Room 1 Set Temperature',
    '°C',
    'Temperature',
    true
  ),
  measurement('MCU_RM1_SET_HUM', 'Room 1 Set Humidity', '%', 'Humidity'),
  measurement('MCU_RM1_TEMP', 'Room 1 Temperature', '°C', 'Temperature', true),
  measurement('MCU_RM1_HUM', 'Room 1 Humidity', '%', 'Humidity'),
  measurement(
    'MCU_RM1_BKP_TEMP',
    'Room 1 Backup Temperature',
    '°C',
    'Temperature'
  ),
  measurement('MCU_RM1_BKP_HUM', 'Room 1 Backup Humidity', '%', 'Humidity'),
  // measurement(
  //   'MCU_RM1_WTR_LVL_ST',
  //   'Room 1 Water Level Status',
  //   '',
  //   'Fault/Status'
  // ),
  // measurement('MCU_RM1_DR_ST', 'Room 1 Door Status', '', 'Fault/Status'),
  measurement(
    'MCU_RM2_SET_TEMP',
    'Room 2 Set Temperature',
    '°C',
    'Temperature'
  ),
  measurement('MCU_RM2_SET_HUM', 'Room 2 Set Humidity', '%', 'Humidity'),
  measurement('MCU_RM2_TEMP', 'Room 2 Temperature', '°C', 'Temperature'),
  measurement('MCU_RM2_HUM', 'Room 2 Humidity', '%', 'Humidity'),
  measurement(
    'MCU_RM2_BKP_TEMP',
    'Room 2 Backup Temperature',
    '°C',
    'Temperature'
  ),
  measurement('MCU_RM2_BKP_HUM', 'Room 2 Backup Humidity', '%', 'Humidity'),
  // measurement(
  //   'MCU_RM2_WTR_LVL_ST',
  //   'Room 2 Water Level Status',
  //   '',
  //   'Fault/Status'
  // ),
  // measurement('MCU_RM2_DR_ST', 'Room 2 Door Status', '', 'Fault/Status'),
  measurement('MCU_REF_FLTS', 'Refrigeration Faults', '', 'Fault/Status'),
  // measurement('MCU_CRUN_CNT', 'C Run Count', '', 'Decimal'),
  measurement('MCU_CRUN_ST', 'CRUN Status', '', 'Fault/Status'),
  measurement('MCU_DIS_TEMP', 'Discharge Temperature', '°C', 'Temperature'),
  measurement('MCU_SUC_TEMP', 'Suction Temperature', '°C', 'Temperature'),
  // measurement('MCU_GRD_RUN_FRQ', 'Grid Run Frequency', 'Hz', 'Frequency'),
  // measurement('MCU_DG_RUN_FRQ', 'DG Run Frequency', 'Hz', 'Frequency'),
  measurement(
    'MCU_MN_VFD_DCBUS_VTG',
    'Main VFD DC Bus Voltage',
    'V',
    'Voltage'
  ),
  measurement('MCU_MN_VFD_PVDC_CRNT', 'Main VFD PV DC Current', 'A', 'Current'),
  measurement(
    'MCU_MN_VFD_OP_FRQ',
    'Main VFD Output Frequency',
    'Hz',
    'Frequency',
    true
  ),
  measurement('MCU_MN_VFD_OP_CRNT', 'Main VFD Output Current', 'A', 'Current'),
  measurement('MCU_MN_VFD_OP_PWR', 'Main VFD Output Power', 'kW', 'Power'),
  measurement(
    'MCU_MN_VFD_HTSNK_TEMP',
    'Main VFD Heatsink Temperature',
    '°C',
    'Temperature'
  ),
  // measurement('MCU_MN_VFD_DI_ST', 'Main VFD DI Status', '', 'Fault/Status'),
  // measurement('MCU_MN_VFD_FLTS_1', 'Main VFD Faults 1', '', 'Fault/Status'),
  // measurement('MCU_MN_VFD_FLTS_2', 'Main VFD Faults 2', '', 'Fault/Status'),
  // measurement(
  //   'MCU_MN_DRV_RD_PARAM',
  //   'Main Drive Read Parameter',
  //   '',
  //   'Decimal'
  // ),
  // measurement(
  //   'MCU_MN_DRV_WR_PARAM',
  //   'Main Drive Write Parameter',
  //   '',
  //   'Decimal'
  // ),
  measurement(
    'MCU_AUX_VFD_DCBUS_VTG',
    'Aux VFD DC Bus Voltage',
    'V',
    'Voltage'
  ),
  measurement('MCU_AUX_VFD_OP_CRNT', 'Aux VFD Output Current', 'A', 'Current'),
  measurement(
    'MCU_AUX_VFD_OP_FRQ',
    'Aux VFD Output Frequency',
    'Hz',
    'Frequency'
  ),
  measurement('MCU_AUX_VFD_OP_PWR', 'Aux VFD Output Power', 'kW', 'Power'),
  measurement(
    'MCU_AUX_VFD_HTSNK_TEMP',
    'Aux VFD Heatsink Temperature',
    '°C',
    'Temperature'
  ),
  // measurement('MCU_AUX_VFD_FLTS_1', 'Aux VFD Faults 1', '', 'Fault/Status'),
  // measurement('MCU_AUX_VFD_FLTS_2', 'Aux VFD Faults 2', '', 'Fault/Status'),
  measurement('MCU_BAT_VTG', 'Battery Voltage', 'V', 'Voltage'),
  measurement('MCU_BAT_CHRG_CRNT', 'Battery Charging Current', 'A', 'Current'),
  measurement('MCU_BAT_LD_CRNT', 'Battery Load Current', 'A', 'Current'),
  // measurement('MCU_BAT_SOC', 'Battery State of Charge', '%', 'Percentage'),
  // measurement('MCU_BAT_LOW_THR', 'Battery Low Threshold', 'V', 'Voltage'),
  // measurement('MCU_BAT_RESV_1', 'Battery Reserved 1', '', 'Decimal'),
  // measurement('MCU_BAT_RESV_2', 'Battery Reserved 2', '', 'Decimal'),
  // measurement('MCU_BK_1_SWV', 'Buck 1 Software Version', '', 'Decimal'),
  // measurement('MCU_BK_1_IP_VTG', 'Buck 1 Input Voltage', 'V', 'Voltage'),
  // measurement('MCU_BK_1_IP_CRNT', 'Buck 1 Input Current', 'A', 'Current'),
  // measurement('MCU_BK_1_OP_CRNT', 'Buck 1 Output Current', 'A', 'Current'),
  // measurement(
  //   'MCU_BK_1_HTSNK_TEMP',
  //   'Buck 1 Heatsink Temperature',
  //   '°C',
  //   'Temperature'
  // ),
  // measurement('MCU_BK_1_FLTS', 'Buck 1 Faults', '', 'Fault/Status'),
  // measurement('MCU_BK_2_SWV', 'Buck 2 Software Version', '', 'Decimal'),
  // measurement('MCU_BK_2_IP_VTG', 'Buck 2 Input Voltage', 'V', 'Voltage'),
  // measurement('MCU_BK_2_IP_CRNT', 'Buck 2 Input Current', 'A', 'Current'),
  // measurement('MCU_BK_2_OP_CRNT', 'Buck 2 Output Current', 'A', 'Current'),
  // measurement(
  //   'MCU_BK_2_HTSNK_TEMP',
  //   'Buck 2 Heatsink Temperature',
  //   '°C',
  //   'Temperature'
  // ),
  // measurement('MCU_BK_2_FLTS', 'Buck 2 Faults', '', 'Fault/Status'),
  measurement(
    'MCU_TNK_1_CHRG_PER',
    'Tank 1 Charge Percentage',
    '%',
    'Percentage'
  ),
  // measurement('MCU_TNK_1_MAX', 'Tank 1 Maximum', '', 'Decimal'),
  // measurement('MCU_TNK_1_OFFSET', 'Tank 1 Offset', '', 'Decimal'),
  measurement(
    'MCU_TNK_2_CHRG_PER',
    'Tank 2 Charge Percentage',
    '%',
    'Percentage'
  ),
  // measurement('MCU_TNK_2_MAX', 'Tank 2 Maximum', '', 'Decimal'),
  // measurement('MCU_TNK_2_OFFSET', 'Tank 2 Offset', '', 'Decimal'),
  measurement('MCU_RL_1', 'Relay 1', '', 'Hex'),
  measurement('MCU_RL_2', 'Relay 2', '', 'Hex'),
  measurement('MCU_RL_3', 'Relay 3', '', 'Hex'),
  measurement('MCU_RL_4', 'Relay 4', '', 'Hex'),
  measurement('MCU_RL_5', 'Relay 5', '', 'Hex'),
  measurement('MCU_RL_6', 'Relay 6', '', 'Hex'),
  measurement('MCU_RL_7', 'Relay 7', '', 'Hex'),
  measurement('MCU_RL_8', 'Relay 8', '', 'Hex'),
  measurement('MCU_RL_9', 'Relay 9', '', 'Hex'),
  measurement('MCU_RL_10', 'Relay 10', '', 'Hex'),
  measurement('MCU_RL_11', 'Relay 11', '', 'Hex'),
  measurement('MCU_RL_12', 'Relay 12', '', 'Hex'),
  measurement('MCU_RL_13', 'Relay 13', '', 'Hex'),
  measurement('MCU_RL_14', 'Relay 14', '', 'Hex'),
  measurement('MCU_RL_15', 'Relay 15', '', 'Hex'),
  measurement('MCU_RL_16', 'Relay 16', '', 'Hex'),
  measurement('MCU_RL_17', 'Relay 17', '', 'Hex'),
  measurement('MCU_RL_18', 'Relay 18', '', 'Hex'),
  measurement('MCU_RL_19', 'Relay 19', '', 'Hex'),
  measurement('MCU_RL_20', 'Relay 20', '', 'Hex'),
  measurement('MCU_RL_21', 'Relay 21', '', 'Hex'),
  measurement('MCU_RL_22', 'Relay 22', '', 'Hex'),
  measurement('MCU_RL_23', 'Relay 23', '', 'Hex'),
  measurement('MCU_RL_24', 'Relay 24', '', 'Hex'),
  measurement('MCU_RESV_1', 'MCU Reserved 1', '', 'Decimal'),
  measurement('MCU_RESV_2', 'MCU Reserved 2', '', 'Decimal'),
  measurement('MCU_RESV_3', 'MCU Reserved 3', '', 'Decimal'),
  measurement('MCU_RESV_4', 'MCU Reserved 4', '', 'Decimal'),
  measurement('MCU_RESV_5', 'MCU Reserved 5', '', 'Decimal'),
  measurement('MCU_RESV_6', 'MCU Reserved 6', '', 'Decimal'),
  measurement('MCU_RESV_7', 'MCU Reserved 7', '', 'Decimal'),
  measurement('MCU_RESV_8', 'MCU Reserved 8', '', 'Decimal')
  // measurement('MCU_CRSH_AD', 'Last Code Crash Address', '', 'Decimal'),
  // measurement('MCU_RST_RSN', 'Last Reset Reason', '', 'Decimal'),
  // measurement('MCU_COM_ST', 'Communication Status', '', 'Fault/Status'),
  // measurement('MCU_CODE_ST', 'Code Status', '', 'Fault/Status')
];

const v4MeasurementMap = () => {
  const map = {};
  for (const item of v4Measurements()) {
    map[item.label] = item;
  }
  return map;
};

export const buildMeasurementsFromV4Params = (params = []) => {
  const knownMeasurements = v4MeasurementMap();

  return params.map(label => {
    const known = knownMeasurements[label];
    if (known) {
      return { ...known, loading: false };
    }

    return measurement(label, label.replace(/_/g, ' '), '', 'Decimal');
  });
};

export default () => v4Measurements();
